'use client';

import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { useCartStore } from 'components/shared/Cart';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { BEST_BUY_PICKUP_ENABLED } from 'utils/featureFlags';
import tagIcon from 'assets/images/best-buy-pickup/tag.svg';
import styles from './SameDayPickupLine.module.css';

type Props = {
  engraving: boolean;
};

/** "Pick up at a Best Buy near you. Choose a size to view stores." under the
 * "Ships by" line on the US Ring PRO buy page. Information only, no date
 * claim: pickup dates are per store and only known after a ZIP. Plain
 * text, no link: the buy flow is sequential, so the pickup choice comes
 * after colour and size. */
export const SameDayPickupLine = (props: Props) => {
  // Module constant: the same branch on every render of a given build.
  if (!BEST_BUY_PICKUP_ENABLED) return null;
  return <SameDayPickupLineInner {...props} />;
};

const SameDayPickupLineInner = ({ engraving }: Props) => {
  const t = useTranslations('ring-pro');
  const cartStore = useCartStore((s) => s.store);
  if (cartStore !== ShopifyStore.US) return null;

  return (
    <p className={styles.line} data-testid="bb-same-day">
      <Image src={tagIcon} alt="" className={styles.icon} />
      <span>
        {engraving
          ? t('ring-pro.bestBuyPickup.sameDayEngraved')
          : t('ring-pro.bestBuyPickup.sameDayLine')}
      </span>
    </p>
  );
};
